import React, { useState, useEffect } from "react";
import "./App.css";

const App = () => {
  const [lists, setLists] = useState(() => {
    const saved = localStorage.getItem("lists");
    return saved ? JSON.parse(saved) : [];
  });

  const [selectedListId, setSelectedListId] = useState(null);
  const [newListName, setNewListName] = useState("");
  const [showAddListInput, setShowAddListInput] = useState(false);

  const [newNoteText, setNewNoteText] = useState("");

  useEffect(() => {
    if (lists.length > 0 && !selectedListId) {
      setSelectedListId(lists[0].id);
    }
    localStorage.setItem("lists", JSON.stringify(lists));
  }, [lists, selectedListId]);

  const listNameExists = (name, excludeId = null) => {
    return lists.some(
      (l) => l.name.toLowerCase() === name.toLowerCase() && l.id !== excludeId
    );
  };

  // ---------- Add List ----------
  const addList = () => {
    const trimmed = newListName.trim();
    if (!trimmed) return;

    if (listNameExists(trimmed)) {
      alert("List name must be unique.");
      return;
    }

    const newList = {
      id: Date.now(),
      name: trimmed,
      notes: []
    };

    setLists([...lists, newList]);
    setSelectedListId(newList.id);
    setNewListName("");
    setShowAddListInput(false);
  };

  // ---------- Delete List ----------
  const deleteList = (listId) => {
    const updated = lists.filter((l) => l.id !== listId);
    setLists(updated);

    if (selectedListId === listId) {
      setSelectedListId(updated.length > 0 ? updated[0].id : null);
    }
  };

  // ---------- Edit List ----------
  const editList = (listId, newName) => {
    const trimmed = newName.trim();
    if (!trimmed) return;

    if (listNameExists(trimmed, listId)) {
      alert("List name must be unique.");
      return;
    }

    setLists(
      lists.map((l) => (l.id === listId ? { ...l, name: trimmed } : l))
    );
  };

  // ---------- Add Note ----------
  const addNote = () => {
    if (!newNoteText.trim()) return;

    setLists(
      lists.map((l) =>
        l.id === selectedListId
          ? {
              ...l,
              notes: [
                ...l.notes,
                { id: Date.now(), text: newNoteText, completed: false }
              ]
            }
          : l
      )
    );

    setNewNoteText("");
  };

  // ---------- Toggle Note ----------
  const toggleNoteCompletion = (noteId) => {
    setLists(
      lists.map((l) =>
        l.id === selectedListId
          ? {
              ...l,
              notes: l.notes.map((n) =>
                n.id === noteId ? { ...n, completed: !n.completed } : n
              )
            }
          : l
      )
    );
  };

  // ---------- Edit Note ----------
  const editNote = (noteId, newText) => {
    setLists(
      lists.map((l) =>
        l.id === selectedListId
          ? {
              ...l,
              notes: l.notes.map((n) =>
                n.id === noteId ? { ...n, text: newText } : n
              )
            }
          : l
      )
    );
  };

  // ---------- Delete Note ----------
  const deleteNote = (noteId) => {
    setLists(
      lists.map((l) =>
        l.id === selectedListId
          ? { ...l, notes: l.notes.filter((n) => n.id !== noteId) }
          : l
      )
    );
  };

  const selectedList = lists.find((l) => l.id === selectedListId);

  return (
    

    <div className="app-container">
      
        
      
      <div className="sidebar">
         <h1 className="sidebar-title">My Notes</h1>
         <ul className="listss">
        <h2>Lists</h2>
         <div className="add-list">
          {!showAddListInput ? (
            <button className="add-btn" onClick={() => setShowAddListInput(true)}>
              +
            </button>
          ) : (
            <div className="add-list-input">
              <input
                type="text"
                placeholder="List name..."
                value={newListName}
                onChange={(e) => setNewListName(e.target.value)}
              />
              <button onClick={addList}>Add</button>
            </div>
          )}
        </div>
        </ul>

        <ul className="list-container scrollable">
          {lists.map((list) => (
            <li
              key={list.id}
              className={list.id === selectedListId ? "active" : ""}
            >
              <input
                type="text"
                value={list.name}
                onChange={(e) => editList(list.id, e.target.value)}
              />
              <button className="view" onClick={() => setSelectedListId(list.id)}>View</button>
              <button className="close" onClick={() => deleteList(list.id)}>X</button>

            </li>
          ))}
        </ul>

        
      </div>

      <div className="main-content">
      <h1>To-Do List Project</h1>
        {selectedList ? (
          <>
            <h2>{selectedList.name}</h2>

            <div className="add-note">
              <input
                type="text"
                placeholder="New note..."
                value={newNoteText}
                onChange={(e) => setNewNoteText(e.target.value)}
              />
              <button onClick={addNote}>+</button>
            </div>

            <ul className="notes-list">
              {selectedList.notes.map((note) => (
                <li key={note.id} className="note-item">
                  <input
                    type="checkbox"
                    checked={note.completed}
                    onChange={() => toggleNoteCompletion(note.id)}
                  />

                  <input
                    type="text"
                    value={note.text}
                    className={note.completed ? "completed" : ""}
                    onChange={(e) => editNote(note.id, e.target.value)}
                    disabled={note.completed}
                  />

                  <button onClick={() => deleteNote(note.id)}>X</button>
                </li>
              ))}
            </ul>
          </>
        ) : (
          <p>Select a list to view notes</p>
        )}
      </div>
    </div>
  );
};

export default App;


/*import React, { useState, useEffect } from "react";
import "./App.css";

const App = () => {
  const [lists, setLists] = useState(() => {
    const saved = localStorage.getItem("lists");
    return saved ? JSON.parse(saved) : [];
  });

  const [selectedListId, setSelectedListId] = useState(
    lists.length > 0 ? lists[0].id : null
  );
  const [newListName, setNewListName] = useState("");
  const [newNoteText, setNewNoteText] = useState("");

  // Persist lists
  useEffect(() => {
    localStorage.setItem("lists", JSON.stringify(lists));
  }, [lists]);

  // ---------- Functions ----------
  const addList = () => {
    if (!newListName.trim()) return;
    const newList = {
      id: Date.now(),
      name: newListName,
      notes: []
    };
    setLists([...lists, newList]);
    setSelectedListId(newList.id);
    setNewListName("");
  };

  const deleteList = (listId) => {
    setLists(lists.filter((l) => l.id !== listId));
    if (selectedListId === listId) {
      setSelectedListId(lists.length > 1 ? lists[0].id : null);
    }
  };

  const editList = (listId, newName) => {
    setLists(
      lists.map((l) => (l.id === listId ? { ...l, name: newName } : l))
    );
  };

  const addNote = () => {
    if (!newNoteText.trim()) return;
    setLists(
      lists.map((l) =>
        l.id === selectedListId
          ? { ...l, notes: [...l.notes, { id: Date.now(), text: newNoteText }] }
          : l
      )
    );
    setNewNoteText("");
  };

  const deleteNote = (noteId) => {
    setLists(
      lists.map((l) =>
        l.id === selectedListId
          ? { ...l, notes: l.notes.filter((n) => n.id !== noteId) }
          : l
      )
    );
  };

  const editNote = (noteId, newText) => {
    setLists(
      lists.map((l) =>
        l.id === selectedListId
          ? {
              ...l,
              notes: l.notes.map((n) =>
                n.id === noteId ? { ...n, text: newText } : n
              )
            }
          : l
      )
    );
  };

  const selectedList = lists.find((l) => l.id === selectedListId);

  // ---------- Render ----------
  return (
    <div className="app-container">
      {/* Sidebar }
      <div className="sidebar">
        <h2>Lists</h2>
        <ul>
          {lists.map((list) => (
            <li
              key={list.id}
              className={list.id === selectedListId ? "active" : ""}
            >
              <input
                type="text"
                value={list.name}
                onChange={(e) => editList(list.id, e.target.value)}
              />
              <button onClick={() => deleteList(list.id)}>X</button>
              <button onClick={() => setSelectedListId(list.id)}>View</button>
            </li>
          ))}
        </ul>
        <div className="add-list">
          <input
            type="text"
            placeholder="New list..."
            value={newListName}
            onChange={(e) => setNewListName(e.target.value)}
          />
          <button onClick={addList}>Add</button>
        </div>
      </div>

      {/* Main content }
      <div className="main-content">
        {selectedList ? (
          <>
            <h2>{selectedList.name}</h2>
            <div className="add-note">
              <input
                type="text"
                placeholder="New note..."
                value={newNoteText}
                onChange={(e) => setNewNoteText(e.target.value)}
              />
              <button onClick={addNote}>+</button>
            </div>
            <ul className="notes-list">
              {selectedList.notes.map((note) => (
                <li key={note.id} className="note-item">
                  <input
                    type="text"
                    value={note.text}
                    onChange={(e) => editNote(note.id, e.target.value)}
                  />
                  <button onClick={() => deleteNote(note.id)}>X</button>
                </li>
              ))}
            </ul>
          </>
        ) : (
          <p>Select a list to view notes</p>
        )}
      </div>
    </div>
  );
};

export default App;

*/


/*import React, { useState, useEffect } from 'react';
import './App.css';

const App = () => {
  const [tasks, setTasks] = useState(() => {
    // Load tasks from localStorage on startup (only runs once)
    const saved = localStorage.getItem('tasks');
    return saved ? JSON.parse(saved) : [];
  });

  const [inputValue, setInputValue] = useState('');

  // Whenever tasks change, save them to localStorage
  useEffect(() => {
    localStorage.setItem('tasks', JSON.stringify(tasks));
  }, [tasks]);

  //  Add new task
  const addTask = () => {
    if (inputValue.trim() === '') return;
    const newTask = {
      id: Date.now(),
      text: inputValue,
      completed: false,
    };
    setTasks([...tasks, newTask]);
    setInputValue('');
  };

  //  Delete task
  const deleteTask = (id) => {
    setTasks(tasks.filter((task) => task.id !== id));
  };

  //  Toggle checkbox
  const toggleComplete = (id) => {
    setTasks(
      tasks.map((task) =>
        task.id === id ? { ...task, completed: !task.completed } : task
      )
    );
  };

  return (
    <div className="app-container">
      <h1> React To-Do List</h1>

      <div className="input-section">
        <input
          type="text"
          placeholder="Enter a new task..."
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
        />
        <button onClick={addTask}>Add</button>
      </div>

      <ul className="task-list">
        {tasks.map((task) => (
          <li key={task.id} className={task.completed ? 'completed' : ''}>
            <label className="task-item">
              <input
                type="checkbox"
                checked={task.completed}
                onChange={() => toggleComplete(task.id)}
              />
              <span>{task.text}</span>
            </label>
            <button onClick={() => deleteTask(task.id)}>X</button>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default App;


*/